import React from 'react';

/**
 * Animal Switcher Radio Button component
 */
const AnimalTypeSwitcherRadioButton = (props) => (
  <div className="col-xs-6">
    <label className="nppe2-fc-animal-type-switcher__radio">
      <input
        type="radio"
        name="nppe2-fc-animal-type-switcher"
        value={props.index}
        checked={props.selected === props.index}
        onChange={() => props.clicked(
          props.index,
          props.data.type
        )}
      />
      <div className="nppe2-fc-animal-type-switcher__background">
        <img className="img-responsive nppe2-fc-animal-type-switcher__img" alt={props.data.label} src={props.data.image} />
        <span className="nppe2-fc-animal-type-switcher__checkmark"></span>
      </div>
    </label>
    <p className="nppe2-fc-animal-type-switcher__text">{props.data.label}</p>
  </div>
);

export default AnimalTypeSwitcherRadioButton;
